var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lastUpdatedAt)?_c('div',{staticClass:"last-updated-at"},[_vm._v("\n  Data last updated"),_c('br'),_vm._v("\n  "+_vm._s(_vm.lastUpdatedFormattedTime)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }